import React from 'react';
import ReactDOM from 'react-dom';

import './styles/main.scss';

import 'jquery';
import 'bootstrap';
import 'materialize-css';
import 'wowjs';
import 'owl.carousel';
import 'waypoints';
import 'magnific-popup';
import 'jquery.counterup';

import registerServiceWorker from './utilities/registerServiceWorker';

import App from './App';

ReactDOM.render(<App/>, document.getElementById('app'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js